/**
 * Token Resources
 *
 * Provides access to design token data.
 */

import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import tokenDefinitions from '../data/token-definitions.json' with { type: 'json' };
import type { TokenDefinitions } from '../types.js';

const tokens = tokenDefinitions as TokenDefinitions;

/**
 * Register token-related resources
 */
export function registerTokenResources(server: McpServer): void {
  // All tokens
  server.resource('tokens://all', 'tokens://all', async (uri) => ({
    contents: [
      {
        uri: uri.href,
        mimeType: 'application/json',
        text: JSON.stringify(tokens, null, 2),
      },
    ],
  }));

  // Color tokens
  server.resource('tokens://colors', 'tokens://colors', async (uri) => ({
    contents: [
      {
        uri: uri.href,
        mimeType: 'application/json',
        text: JSON.stringify(tokens.colors, null, 2),
      },
    ],
  }));

  // Spacing tokens
  server.resource('tokens://spacing', 'tokens://spacing', async (uri) => ({
    contents: [
      {
        uri: uri.href,
        mimeType: 'application/json',
        text: JSON.stringify(tokens.spacing, null, 2),
      },
    ],
  }));

  // Typography tokens
  server.resource('tokens://typography', 'tokens://typography', async (uri) => ({
    contents: [
      {
        uri: uri.href,
        mimeType: 'application/json',
        text: JSON.stringify(tokens.typography, null, 2),
      },
    ],
  }));
}
